import "../styles/Header.css";

export default function Header() {
  return (
    <header className="header">
      <nav className="header__nav">
        <ul className="header__nav-icons">
          <li className="header__nav-icon">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/in/callum-underwood/"
            >
              <img
                src="/linkedin.png"
                alt="LinkedIn logo"
                className="header__nav-link"
              />
            </a>
          </li>
          <li className="header__nav-icon">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.github.com/callumu21"
            >
              <img
                src="/github.png"
                alt="GitHub logo"
                className="header__nav-link"
              />
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}
